import { quickpackApi } from '~/services/api';

import {
  type InsertPrinters,
  type UpsertRemotePrintPreferences,
  type UpsertWorkstation,
  type WorkstationsList,
} from '../types/print.type';

export const listWorkstations = async (): Promise<WorkstationsList> => {
  const response = await quickpackApi.request<WorkstationsList>({
    method: 'GET',
    url: '/workstations',
  });
  return response.data;
};

export const upsertWorkstation = async (data: UpsertWorkstation): Promise<void> => {
  await quickpackApi.request<void>({
    data,
    method: 'POST',
    url: '/workstations',
  });
};

export const insertPrinters = async (hostnameKey: string, data: InsertPrinters): Promise<void> => {
  await quickpackApi.request<void>({
    data,
    method: 'POST',
    url: `/workstations/${hostnameKey}/printers`,
  });
};

export const updatePrintPreferences = async (
  hostnameKey: string,
  data: UpsertRemotePrintPreferences,
): Promise<void> => {
  await quickpackApi.request<void>({
    data,
    method: 'PUT',
    url: `/workstations/${hostnameKey}/print-preferences`,
  });
};
